// ═══════════════════════════════════════════════════════════════
// useModulePermission — Simple hook for checking edit/admin access
// Usage: const { canEdit, canAdmin } = useModulePermission('debris');
// ═══════════════════════════════════════════════════════════════

import { usePermission } from './usePermission';
import type { ModuleId } from '../types/rbac';

export function useModulePermission(moduleId: ModuleId) {
  const access = usePermission(moduleId);
  return {
    canView: access.canView,
    canEdit: access.canEdit,
    canAdmin: access.canAdmin,
    level: access.level,
  };
}
